module.exports = __webpack_public_path__ + "static/media/ice01.222512eb.webp";